import { render, staticRenderFns } from "./RolesGroupsList.vue?vue&type=template&id=28e9a662&scoped=true&"
import script from "./RolesGroupsList.vue?vue&type=script&lang=js&"
export * from "./RolesGroupsList.vue?vue&type=script&lang=js&"
import style0 from "./RolesGroupsList.vue?vue&type=style&index=0&id=28e9a662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9a662",
  null
  
)

export default component.exports